var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('SearchObject', {
    ref: "search",
    attrs: {
      "additional-params": Object.assign({
        ordering: 'name'
      }, _vm.additionalParams),
      "allow-create": _vm.allowCreate,
      "autofocus": _vm.autofocus,
      "base-url": _vm.baseUrl,
      "create-label": _vm.$translate('create_logistics_operator'),
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "item-text": _vm.itemText,
      "label": _vm.label || _vm.$translate('select_logistics_operator'),
      "readonly": _vm.readonly,
      "required": _vm.required,
      "value": _vm.value,
      "icon": _vm.icon,
      "flat": _vm.flat,
      "outlined": _vm.outlined,
      "background-color": _vm.backgroundColor,
      "error-messages": _vm.errorMessages,
      "dense": _vm.dense
    },
    on: {
      "create": _vm.createOperator,
      "input": _vm.onSearchInput,
      "select": function select($event) {
        return _vm.$emit('select', $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('span', [_vm._v(_vm._s(_vm.itemText(item)))]), item.entity ? _c('span', {
          staticClass: "text-caption text--secondary ml-2"
        }, [_vm._v(" (" + _vm._s(_vm.$translate("connected")) + ") ")]) : _vm._e()];
      }
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }